import styled from 'styled-components/macro'

const TableRow = styled.tr`

`

export default TableRow
